import { render } from "./fieldTipTap.vue?vue&type=template&id=34cf42b6"
import script from "./fieldTipTap.vue?vue&type=script&lang=js"
export * from "./fieldTipTap.vue?vue&type=script&lang=js"

import "./fieldTipTap.vue?vue&type=style&index=0&id=34cf42b6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__